module.exports = __webpack_public_path__ + "static/media/map.243144b1.jpg";